import _ from 'lodash';

import { buildPaths } from './helpers';

export function scrollToErrors(formErrors) {
    let errors = buildPaths(formErrors);
    let input =
        document.querySelector(`[name="${_.first(errors)}"]`) ||
        document.querySelector('.invalid input') ||
        document.querySelector('.error');
    input &&
        document.activeElement !== input &&
        input.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
        });
}
